import React from 'react';
import { MemoryRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import TermsOfService from './pages/TermsOfService';

export default function App() {
  return (
    <MemoryRouter initialEntries={['/terms']}>
      <Layout>
        <Routes>
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="*" element={<Navigate to="/terms" replace />} />
        </Routes>
      </Layout>
    </MemoryRouter>
  );
}
